import './index.css';
import L from 'leaflet';
import serializeStyle from '../serializeStyle';

import './index.css';

const OPTIONS = {
  latLng: [51.505, -0.094],
  imageUrl: '//imgcdn1.zuzuche.com/m_tantu_image/20170316/3c24d0da7611d7fce2423c370288f171.png',
  size: {
    width: '0.6rem',
    height: '0.6rem'
  },
  index: false,
  message: '',
  className: ''
};


export default function locateMarker(options = {}, markerOptions = {}) {
  options = {...OPTIONS, ...options};

  let size = serializeStyle(options.size);
  let bg = serializeStyle({
    'background-image': `url(${options.imageUrl})`
  });
  let className = `pic ${options.className}`;

  let rootSize = parseInt(document.documentElement.style.fontSize, 10);

  // divIcon 实例
  let icon = L.divIcon({
    iconSize: [
      rootSize * parseFloat(options.size.width),
      rootSize * parseFloat(options.size.height)
    ],
    className: 'component-map-locate-marker',
    html: `<div style="${size}">
            <div class="${className}" style="${bg}"></div>
          </div>`
  });

  markerOptions.icon = icon;
  let marker = L.marker(options.latLng, markerOptions);

  return marker;
}




// WEBPACK FOOTER //
// ./src/components/Map/locateMarker/index.js